import { FaChartLine } from "react-icons/fa6";

const LiveAnalyticsIcon = () => {
  return <FaChartLine size={23} className="sidebar-icon" />;
};

export default LiveAnalyticsIcon;
